import { render, staticRenderFns } from "./Pays.vue?vue&type=template&id=71022bc1"
import script from "./Pays.vue?vue&type=script&lang=js"
export * from "./Pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports